// extracted by mini-css-extract-plugin
export default {"cls1":"LoswpMoreActionsMenu-cls1_o9r","cls2":"LoswpMoreActionsMenu-cls2__xV LoswpMoreActionsMenu-cls1_o9r"};